// extracted by mini-css-extract-plugin
export default {"globird-or-pip":"GlobirdOr_globird-or-pip__5DbOk","divider":"GlobirdOr_divider__rcBGz"};